import React from 'react'
import { MultiSelect } from '@baseV2'
import { isSuperAdmin } from 'src/utils/adminFilter'
import { isBrandOptional } from '@utils'
import { FieldItem, RequiredAsterisk } from './styles'

// Brands are mandatory everywhere except on the solar commodity, where items are not brand-driven.
const BrandsField = ({ brands, onChange, user }) => (
	<FieldItem>
		<MultiSelect
			id='enquiry-brands-select'
			disabled={brands?.disabled}
			label={
				<>
					{brands?.label}
					{!isBrandOptional(user) && <RequiredAsterisk>*</RequiredAsterisk>}
				</>
			}
			displayKey={brands?.displayKey}
			primaryKey={brands?.primaryKey}
			placeholder={brands?.placeholder}
			data={brands?.data}
			value={brands?.value}
			onChange={onChange}
			uppercase
			createNewOption={isSuperAdmin(user?.role)}
			hideSelectAll
		/>
	</FieldItem>
)

export default BrandsField
